module.exports = __webpack_public_path__ + "static/media/true-digital-range.a0b7e447.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/trueDigital/true-digital-range.png
// module id = 3571
// module chunks = 0